import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { IProfileState } from './profile-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION } from '../action-types';
import { mergeMap } from 'rxjs';
import { IAppRouterState } from '../router/router-state';
import {
    PROFILE,
    PROFILE_LOGINDETAILS,
    PROFILE_LOGINDETAILS_PHONEVERIFICATION
} from '@core/router/app-states';
import { RouterGoAction, RouterNavigationCancelAction } from '../router/router-actions';

@Injectable()
export class ProfileEffects {

    constructor(private store$: Store<IProfileState>,
                private actions$: Actions) {
    }

    profileRouter$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ROUTER_NAVIGATION),
            mergeMap((action: Action) => {
                const actions: Action[] = [];
                const routerState: IAppRouterState = (action as any).payload
                        .routerState as IAppRouterState;
                    const { name: stateName, fromState, params } = routerState;

        
                if (stateName === PROFILE_LOGINDETAILS_PHONEVERIFICATION) {
                    if (fromState.name !== PROFILE_LOGINDETAILS || !params?.phone) {

                        actions.push(new RouterNavigationCancelAction({ state: PROFILE_LOGINDETAILS_PHONEVERIFICATION }));
                        actions.push(new RouterGoAction({ name: PROFILE }));
                    }
                }

                return actions;
            })
        );
    })
}
